var React = require('react');

function IconMapSettingsWorkshopPoisInactive (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"#A7AFBB","fillRule":"evenodd","d":"M12.262 9.055a5.362 5.362 0 0 1 6.871 6.873c.016.015 3.36 3.358 10.032 10.031l2.102 2.102-3.201 3.2-12.057-12.158a5.362 5.362 0 0 1-6.951-6.85l3.785 3.787 3.202-3.202-1.474-1.474zm3.758 11.838l.948.947 1.264 1.264.947.948-7.19 7.19-3.158-3.16 7.19-7.19zM29.818 9.105l1.264 1.264-1.896 3.159-1.895.631-4.056 4.057-1.264-1.264 4.057-4.056.631-1.895 3.16-1.896z"}));
}

IconMapSettingsWorkshopPoisInactive.defaultProps = {"width":"40","height":"40"};

module.exports = IconMapSettingsWorkshopPoisInactive;

IconMapSettingsWorkshopPoisInactive.default = IconMapSettingsWorkshopPoisInactive;
